const LOCALSTORAGEKEY = "firstmediaVue.settings";

function readFromLocalStorage() {
    let settings = localStorage.getItem(LOCALSTORAGEKEY);
    if (!settings) {
        settings = resetSettings();
    } else {
        try {
            settings = JSON.parse(settings);
        } catch (error) {
            settings = resetSettings();
        }
        if (!isSettingsValid(settings)) {
            settings = resetSettings();
        }
    }
    return settings;
}

function readFromEvent(event) {
    if (event.key != LOCALSTORAGEKEY) {
        return null;
    }
    let settings = {};
    try {
        settings = JSON.parse(event.newValue);
    } catch (error) {
        settings = resetSettings();
    }
    if (!isSettingsValid(settings)) {
        settings = resetSettings();
    }
    return settings;
}

function isSettingsValid(settings) {
    if (!settings) {
        return false;
    }

    // if (!('FavSets' in settings)) {
    //     return false;
    // }

    if (!(settings.FavSets instanceof Array)) {
        return false;
    }

    for (const set of settings.FavSets) {
        if (!(set.Channels instanceof Array)) {
            return false;
        }

        for (const channel of set.Channels) {
            if (!('Number' in channel)) {
                return false;
            }

            if (!('Name' in channel)) {
                return false;
            }
        }

        if (!('Description' in set)) {
            return false;
        }
    }

    if (!('SelectedSet' in settings)) {
        return false;
    }

    return true;
}

function getDefaultSettings() {
    let settings = {
        FavSets: [
            {
                Description: 'First Set',
                Channels: [
                    { Number: 1, Name: 'BERITA SATU HD' },
                    { Number: 15, Name: 'KOMPAS TV' }
                ]
            },
            {
                Description: 'Second Set',
                Channels: [
                    { Number: 373, Name: 'DISNEY HD' },
                    { Number: 328, Name: 'FOX HD' }
                ]
            }
        ],
        SelectedSet: 0
    }
    return settings;
}

function resetSettings() {
    let s = getDefaultSettings();
    let ss = JSON.stringify(s);
    localStorage.setItem(LOCALSTORAGEKEY, ss);
    return s;
}

function writeToLocalStorage(settings) {
    if (!isSettingsValid(settings)) {
        throw "Invalid Settings"
    }
    let settingsString = JSON.stringify(settings);
    localStorage.setItem(LOCALSTORAGEKEY, settingsString);
}

const SettingsVuexModule = {
    namespaced: true,
    state: {
        settings: {},
    },
    getters: {
        //
    },
    mutations: {
        update: (state, updatedSettings) => {
            state.settings = updatedSettings;
        },
    },
    actions: {
        initialize: context => {
            let settings = readFromLocalStorage();
            context.commit('update', settings);
        },
        updateAll: (context, settings) => {
            writeToLocalStorage(settings);
            context.commit('update', settings);
        },
        parseStorageEvent: (context, event) => {
            let settings = readFromEvent(event);
            if (!!settings) {
                context.commit('update', settings);
            }
        },
    },
}

export default SettingsVuexModule;
